// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar-select .sk-select,\n.avatar-select .sk-select.is-opened {\n  height: 0;\n  border: none;\n}\n.avatar-select .sk-select.is-opened .sk-select__list {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  min-width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
